import React from 'react'
import _ from 'lodash'
import moment from 'moment'
import { Typography } from '@mui/material'
import { PROGRAM_KEY, FAMILY_KEY, PROGRAM_WORKFLOW } from '../../constants/common'
import { applicationsService } from "../../services"

const SITE_STATUS = {
  SITE_SUBMITTED: 'Site_Submitted',
  SITE_REJECTED: 'Site_Rejected',
  SITE_APPROVED: 'Site_Approved',
  APPLICATION_SUBMITTED: 'Application_Submitted',
  APPLICATION_REJECTED: 'Application_Rejected',
  APPLICATION_APPROVED: 'Application_Approved',
  APPLICATION_UNENROLLED: 'UNENROLLED'
}

const PAYMENT_TYPE = {
  UPFRONT_PAYMENT: 'One Time Payment',
  MONTHLY_INSTALLMENT: 'Monthly Installment'
}

const INCENTIVE_CATEGORY = {
  STANDARD: 'Standard',
  UNDERSERVED: 'Underserved',
  LOW_INCOME: 'Low Income'
}

const applicationStatus = (key, familyKey, workflow) => {
  if (workflow === PROGRAM_WORKFLOW.API_FLOW) {
    return [
      {
        label: 'Submitted for Review',
        color: '#CFC338',
        value: SITE_STATUS.APPLICATION_SUBMITTED
      },
      {
        label: 'Approved',
        color: '#35C37D',
        value: SITE_STATUS.APPLICATION_APPROVED
      },
      {
        label: 'Rejected',
        color: '#FF6565',
        value: SITE_STATUS.APPLICATION_REJECTED
      },
      {
        label: 'Unenrolled',
        color: '#808080',
        value: SITE_STATUS.APPLICATION_UNENROLLED
      }
    ]
  }
  if (key === PROGRAM_KEY.PSEG_LI) {
    return [
      {
        label: 'Submitted for Enphase Review',
        value: SITE_STATUS.APPLICATION_SUBMITTED
      },
      {
        label: 'Rejected by Enphase',
        value: SITE_STATUS.APPLICATION_REJECTED
      },
      {
        label: 'Submitted for PSEG Review',
        value: SITE_STATUS.APPLICATION_APPROVED
      },
      {
        label: 'Approved by PSEG',
        value: SITE_STATUS.SITE_APPROVED
      },
      {
        label: 'Rejected by PSEG',
        value: SITE_STATUS.SITE_REJECTED
      }
    ]
  }

  if (familyKey === FAMILY_KEY.CT_ESS) {
    return [
      {
        label: 'Submitted for Enphase Review',
        value: SITE_STATUS.APPLICATION_SUBMITTED
      },
      {
        label: 'Rejected by Enphase',
        value: SITE_STATUS.APPLICATION_REJECTED
      },
      {
        label: 'Submitted for Utility Review',
        value: SITE_STATUS.APPLICATION_APPROVED
      },
      {
        label: 'Approved by Utility',
        value: SITE_STATUS.SITE_APPROVED
      },
      {
        label: 'Rejected by Utility',
        value: SITE_STATUS.SITE_REJECTED
      }
    ]
  }

  if (key === PROGRAM_KEY.GMP_ENPH || key === PROGRAM_KEY.APS_RBP) {
    return [
      {
        label: 'Submitted for Review',
        color: '#CFC338',
        value: SITE_STATUS.SITE_SUBMITTED
      },
      {
        label: 'Approved',
        color: '#35C37D',
        value: SITE_STATUS.SITE_APPROVED
      },
      {
        label: 'Rejected',
        color: '#FF6565',
        value: SITE_STATUS.SITE_REJECTED
      }
    ]
  }

  return [
    {
      label: 'Submitted for Review',
      color: '#CFC338',
      value: SITE_STATUS.APPLICATION_SUBMITTED
    },
    {
      label: 'Approved',
      color: '#35C37D',
      value: SITE_STATUS.APPLICATION_APPROVED
    },
    {
      label: 'Rejected',
      color: '#FF6565',
      value: SITE_STATUS.APPLICATION_REJECTED
    },
    {
      label: 'Unenrolled',
      color: '#808080',
      value: SITE_STATUS.APPLICATION_UNENROLLED
    }
  ]
}

const STATUS = {
  APPROVED: 'Approved',
  REJECTED: 'Rejected'
}

const TYPE = {
  DATA_AND_DISPATCH: 'Data and Dispatch',
  DATA_ONLY: 'Data Only'
}

const batteryDetailsWrapper = {
  display: 'flex',
  justifyContent: 'space-between',
  width: '70%'
}

const batteryDetailsStyle = {
  background: 'rgb(233 229 229)',
  borderRadius: '3px',
  height: '20px',
  width: '20px',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center'
}

const FORM_IDS = {
  SITE_ID: 'site_id',
  NAME: 'name',
  FIRST_NAME: 'first_name',
  LAST_NAME: 'last_name',
  EMAIL: 'email_address',
  PHONE: 'phone',
  ADDRESS: 'address',
  ADDRESS1: 'address1',
  ADDRESS2: 'address2',
  CITY: 'city',
  STATE: 'state',
  ZIP: 'zip',
  KW_COMMITTED: 'kw_capacity_committed',
  PROGRAM_TYPE: 'program_type',
  ELECTRIC_ACCOUNT_NO: 'electric_account_number',
  METER_NO: 'utility_meter_number',
  PAYMENT_METHOD: 'payment_method',
  INCENTIVE_CATEGORY: 'event_incentive_category',
  PTO: 'pto',
  UTILITY_ID: 'utility_id',
  ENCHARGE3: 'encharge3',
  ENCHARGE10: 'encharge10',
  ENCHARGE5P: 'encharge5P'
}

const getField = (type, details, label, subIds, utilityName) => {
  const { homeowner_info } = details
  const address1 = _.get(homeowner_info, 'address1', '')
  const address2 = _.get(homeowner_info, 'address2', '')
  const address = address1 && address2 ? `${address1},${address2}` : `${address1}${address2}`

  switch (type) {
    case FORM_IDS.SITE_ID: {
      return {
        id: FORM_IDS.SITE_ID,
        label: label ? label : 'Site Id',
        value: _.get(details, 'site_id', ''),
        status: ''
      }
    }
    case FORM_IDS.FIRST_NAME: {
      return {
        id: FORM_IDS.FIRST_NAME,
        label: label ? label : 'Customer First Name',
        value: `${_.get(homeowner_info, 'first_name', '')}`,
        status: ''
      }
    }
    case FORM_IDS.LAST_NAME: {
      return {
        id: FORM_IDS.LAST_NAME,
        label: label ? label : 'Customer Last Name',
        value: `${_.get(homeowner_info, 'last_name', '')}`,
        status: ''
      }
    }
    case FORM_IDS.NAME: {
      return {
        id: FORM_IDS.NAME,
        label: 'Name of customer',
        value: `${_.get(homeowner_info, 'first_name', '')} ${_.get(homeowner_info, 'last_name', '')}`,
        status: ''
      }
    }
    case FORM_IDS.EMAIL: {
      return {
        id: FORM_IDS.EMAIL,
        label: label ? label : 'Email Address',
        value: _.get(homeowner_info, 'email_address', ''),
        status: ''
      }
    }
    case FORM_IDS.PHONE: {
      return {
        id: FORM_IDS.PHONE,
        label: 'Phone Number',
        value: _.get(homeowner_info, 'phone', ''),
        status: ''
      }
    }
    case FORM_IDS.ADDRESS: {
      return {
        id: FORM_IDS.ADDRESS,
        label: 'Address',
        value: address,
        status: ''
      }
    }
    case FORM_IDS.ADDRESS1: {
      return {
        id: FORM_IDS.ADDRESS1,
        label: label ? label : 'Address Line 1',
        value: _.get(homeowner_info, 'address1', ''),
        status: ''
      }
    }
    case FORM_IDS.ADDRESS2: {
      return {
        id: FORM_IDS.ADDRESS2,
        label: label ? label : 'Address Line 2',
        value: _.get(homeowner_info, 'address2', ''),
        status: ''
      }
    }
    case FORM_IDS.CITY: {
      return {
        id: FORM_IDS.CITY,
        label: label ? label : 'City',
        value: _.get(homeowner_info, 'city', ''),
        status: ''
      }
    }
    case FORM_IDS.STATE: {
      return {
        id: FORM_IDS.STATE,
        label: label ? label : 'State',
        value: _.get(homeowner_info, 'state', ''),
        status: ''
      }
    }
    case FORM_IDS.ZIP: {
      return {
        id: FORM_IDS.ZIP,
        label: label ? label : 'Zipcode',
        value: _.get(homeowner_info, 'zip', ''),
        status: ''
      }
    }
    case FORM_IDS.KW_COMMITTED: {
      return {
        id: FORM_IDS.KW_COMMITTED,
        label: label ? label : 'kW capacity for data sharing',
        value: _.get(homeowner_info, 'kw_capacity_committed', ''),
        status: ''
      }
    }
    case FORM_IDS.PROGRAM_TYPE: {
      return {
        id: FORM_IDS.PROGRAM_TYPE,
        label: 'Program Option',
        value: TYPE[_.get(homeowner_info, 'program_type', '')],
        status: ''
      }
    }
    case FORM_IDS.ELECTRIC_ACCOUNT_NO: {
      return {
        id: FORM_IDS.ELECTRIC_ACCOUNT_NO,
        label: label ? label : 'Electric Account Number',
        value: _.get(homeowner_info, 'electric_account_number', ''),
        status: ''
      }
    }
    case FORM_IDS.METER_NO: {
      return {
        id: FORM_IDS.METER_NO,
        label: label ? label : 'PSEG Long Island Electric Meter Number',
        value: _.get(homeowner_info, 'utility_meter_number', ''),
        status: ''
      }
    }
    case FORM_IDS.PAYMENT_METHOD: {
      return {
        id: FORM_IDS.PAYMENT_METHOD,
        label: label ? label : 'Program Payment Option Type',
        value: PAYMENT_TYPE[_.get(details, 'payment_method', '')] || '--',
        status: ''
      }
    }
    case FORM_IDS.INCENTIVE_CATEGORY: {
      return {
        id: FORM_IDS.INCENTIVE_CATEGORY,
        label: label ? label : 'Incentive Category',
        value: INCENTIVE_CATEGORY[_.get(details, 'event_incentive_category', '')] || '--',
        status: ''
      }
    }
    case FORM_IDS.PTO: {
      return {
        id: FORM_IDS.PTO,
        label: label ? label : 'Permission To Operate Date',
        value: moment(_.get(details, 'pto', '')).format('DD/MM/YYYY'),
        status: ''
      }
    }
    case FORM_IDS.UTILITY_ID: {
      return {
        id: FORM_IDS.UTILITY_ID,
        label: 'Utility',
        value: utilityName,
        status: ''
      }
    }
    case 'GROUPABLE_COUNTER': {
      return {
        id: 'GROUPABLE_COUNTER',
        label: label ? label : 'Battery Details',
        value: subIds.map(id => (
          id === FORM_IDS.ENCHARGE3 ? <Typography style={batteryDetailsWrapper}>IQ Battery 3<Typography style={batteryDetailsStyle}>{_.get(homeowner_info, 'encharge3', '-')}</Typography></Typography> : id === FORM_IDS.ENCHARGE10 ? <Typography style={batteryDetailsWrapper}>IQ Battery 10 <Typography style={batteryDetailsStyle}>{_.get(homeowner_info, 'encharge10', '-')}</Typography></Typography> : <Typography style={batteryDetailsWrapper}>IQ Battery 5P <Typography style={batteryDetailsStyle}>{_.get(homeowner_info, 'encharge5P', '-')}</Typography></Typography>
        )),
        status: ''
      }
    }
    default:
      return
  }
}

const getForms = async (key, familyKey) => {
  let formFields = []
  await applicationsService.getDynamicForms(key)
    .then((res) => {
      const { fields } = res
      let filteredFields = _.cloneDeep(fields)
      filteredFields = filteredFields.filter(obj => !obj.hidden)
      if (familyKey === FAMILY_KEY.CT_ESS) {
        filteredFields.forEach(obj => {
          if (obj.type === 'GROUPABLE_COUNTER') {
            const index = formFields.findIndex(list => list.id === obj.type)
            if (index > -1) {
              formFields[index].subIds.push(obj.application_field)
            } else {
              formFields.push({
                id: obj.type,
                label: obj.label,
                subIds: [obj.application_field]
              })
            }
          } else {
            formFields.push({ id: obj.application_field, label: obj.label })
          }
        })
      } else {
        formFields = filteredFields.map(obj => { return { id: obj.application_field, label: obj.label } })
      }
    })
  return formFields
}

const getFormFields = async (programKey, familyKey) => {
  let formFields = []
  let key = familyKey ? familyKey : programKey
  switch (key) {
    case PROGRAM_KEY.APS_RBP: {
      formFields = [
        { id: FORM_IDS.SITE_ID },
        { id: FORM_IDS.NAME },
        { id: FORM_IDS.EMAIL },
        { id: FORM_IDS.PHONE },
        { id: FORM_IDS.ADDRESS1 },
        { id: FORM_IDS.ADDRESS2 },
        { id: FORM_IDS.CITY },
        { id: FORM_IDS.STATE },
        { id: FORM_IDS.ZIP },
        { id: FORM_IDS.KW_COMMITTED },
        { id: FORM_IDS.PROGRAM_TYPE }
      ]
      break
    }
    case FAMILY_KEY.CT_ESS: {
      if (programKey) {
        const formList = await getForms(programKey, familyKey)
        formFields = [
          { id: FORM_IDS.UTILITY_ID },
          ...formList
        ]
      }
      break
    }
    case PROGRAM_KEY.PSEG_LI: {
      formFields = await getForms(programKey)
      break
    }
    case PROGRAM_KEY.GMP_BYOD: {
      formFields = await getForms(programKey)
      break
    }
    case PROGRAM_KEY.SWELL: {
      formFields = [
        { id: FORM_IDS.SITE_ID },
        { id: FORM_IDS.NAME },
        { id: FORM_IDS.EMAIL },
        { id: FORM_IDS.PHONE },
        { id: FORM_IDS.ADDRESS1 },
        { id: FORM_IDS.ADDRESS2 },
        { id: FORM_IDS.CITY },
        { id: FORM_IDS.STATE },
        { id: FORM_IDS.ZIP }
      ]
      break
    }
    default: {
      formFields = [
        { id: FORM_IDS.NAME },
        { id: FORM_IDS.ADDRESS },
        { id: FORM_IDS.CITY },
        { id: FORM_IDS.STATE },
        { id: FORM_IDS.ZIP },
        { id: FORM_IDS.ELECTRIC_ACCOUNT_NO },
        { id: FORM_IDS.PAYMENT_METHOD }
      ]
      break
    }
  }

  return formFields
}

const getFormDetails = async (formFields, details, utilityName) => {
  return !formFields ? [] : formFields.map(obj => getField(obj.id, details, obj.label, obj.subIds, utilityName))
}

export {
  applicationStatus,
  getFormDetails,
  getFormFields,
  STATUS,
  SITE_STATUS,
  FORM_IDS
}